import { createFileRoute } from '@tanstack/react-router'
import EditionBookAndAuthor from 'Edition/components/sections/Content/EditionBookAndAuthor'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/content-title-portrait')({
    component: EditionBookAndAuthor,
})
